<template>
    <section class="team" :class="$mq">
        <base-text type="h4" class="heading">{{ heading }}</base-text>
        <div class="team-grid">
            <team-member
                v-for="(member, index) in members"
                :key="index"
                :name="member.name"
                :position="member.position"
                :portfolio="member.portfolio || null"
                :photo="member.photo"
            />
        </div>
    </section>
</template>

<script>
    import TeamMember from '../components/TeamMember';

    export default {
        name: 'team-section',

        components: {
            TeamMember,
        },

        props: {
            heading: {
                type: String,
                required: true,
            },

            members: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    section.team {
        margin-bottom: 50px;

        .heading {
            margin-bottom: 20px;
        }

        .team-grid {
            display: grid;
            grid-gap: 30px;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        }

        &.tablet,
        &.mobile {
            .team-grid {
                grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            }
        }
    }
</style>
